import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-station',
  templateUrl: './station.component.html',
  styleUrls: ['./station.component.css']
})
export class StationComponent implements OnInit {

  project;
  profile;
  rooms   = []; 
  showRoomSetting;
  constructor(public cm:CommonService) { 
    this.cm.getMessage().subscribe((massage)=>{
      if(massage.command == 'menu2'){
        this.clickMenu();
      }
    })

  }

  ngOnInit() {

    this.profile = this.cm.getProfile();
    this.project = this.cm.getProject();
    this.rooms   = this.cm.getRoom();
    
    this.getStationFromFirebase();
  }

  isShowMenu = true;
  clickMenu(){
    this.isShowMenu = !this.isShowMenu;
    this.cm.sendMessage('menu',String(this.isShowMenu));
  }

  stations = [];
  getStationFromFirebase(){
    this.cm.db.collection('stations',ref => ref.where("project_uid","==",this.project.uid)).get().toPromise().then((data)=>{
      this.stations = [];
      for(var i = 0;i < data.docs.length;i++){
        var station_data = data.docs[i].data();
        this.stations.push(station_data);
      }
      this.data_show = this.stations;
    });
  }

  change_current_station(uid,amp_s){
    let amp = prompt("Please enter current (0 - 32 A)",amp_s);
    if(amp != null && parseInt(amp) >= 0 && parseInt(amp) <= 32){
      this.cm.db.collection('stations').doc(uid).update({
        set_current_charge:amp
      }).then(()=>{
        // send mqtt to station
        this.cm.db.collection('requests_station').add({
          command:'1',
          project_uid:this.project.uid,
          station_uid:uid,
          set_current_charge:amp
        }).then(()=>{
          this.getStationFromFirebase();
          this.cm.toastr.success('SETTING','SUCCESS');
        })
      });

      

    } else {
      this.cm.toastr.warning('SOMETHING WENT WRONG','WARNING');
    }
  }

  @ViewChild("input_search_text") inputEl: ElementRef;
  data_show;
  search(text){
    this.data_show = [];
    for(var i = 0;i<this.stations.length;i++){
      var sameData = 0;
      for (var key in this.stations[i]) {
        if(String(this.stations[i][key]).match(text)){
            this.data_show.push(this.stations[i]);
            sameData = 1;
        }

        for (var key in this.stations[i].attribute) {
          if(String(this.stations[i].attribute[key]).match(text) && sameData == 0){
              this.data_show.push(this.stations[i]);
          }
        } 
        sameData = 0;
      } 
    }
    this.data_show = this.cm.removeDuplicates(this.data_show,'uid');
  }

}
